// extracted by mini-css-extract-plugin
module.exports = {"componentsStickyDownload":"styles_componentsStickyDownload__h9cf1"};